export interface AccountData {
  authMethod: 'google' | 'email';
  fullName: string;
  email: string;
  password?: string;
  accountId?: string;
}

export interface AddressDetails {
  formattedAddress: string;
  placeId?: string;
}

export interface BusinessProfileData {
  businessName: string;
  vanityUrl: string;
  phone: string;
  taxRegNumber: string;
  address: string;
  addressDetails?: AddressDetails;
  description: string;
}

export type ServiceId =
  | 'physiotherapy'
  | 'acupuncture'
  | 'massage'
  | 'osteopath'
  | 'kinotherapy'
  | 'other';

export interface ServicesData {
  selectedServices: ServiceId[];
  otherService: string;
}

export interface DaySchedule {
  open: boolean;
  from: string;
  to: string;
}

export type DayOfWeek =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';

export type ScheduleData = Record<DayOfWeek, DaySchedule>;

export interface BusinessSettings {
  account: AccountData | null;
  profile: BusinessProfileData | null;
  services: ServicesData | null;
  schedule: ScheduleData | null;
  completedAt: string | null;
}

export type ApiDayCode = 'MON' | 'TUE' | 'WED' | 'THU' | 'FRI' | 'SAT' | 'SUN';

export interface HoursScheduleEntry {
  day: ApiDayCode;
  isClosed: boolean;
  startTime: string | null;
  endTime: string | null;
}

export interface UpdateHoursRequest {
  timezone: string;
  schedule: HoursScheduleEntry[];
}

export interface UpdateHoursResponse {
  timezone: string;
  schedule: HoursScheduleEntry[];
}

export interface UpdateProfileRequest {
  businessName: string;
  legalName?: string;
  bookingSubdomain: string;
  businessDescription?: string;
  tax?: {
    taxRegistrationNumber?: string;
    taxRegistrationType?: 'VAT';
  };
}

export interface UpdateProfileResponse {
  businessName: string;
  legalName?: string;
  bookingSubdomain: string;
  bookingURL: string;
  logoURL?: string;
  businessDescription?: string;
  tax?: {
    taxRegistrationNumber?: string;
    taxRegistrationType?: string;
  };
}

export const DAYS_OF_WEEK: DayOfWeek[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const DEFAULT_SCHEDULE: ScheduleData = {
  monday: { open: true, from: '09:00', to: '17:00' },
  tuesday: { open: true, from: '09:00', to: '17:00' },
  wednesday: { open: true, from: '09:00', to: '17:00' },
  thursday: { open: true, from: '09:00', to: '17:00' },
  friday: { open: true, from: '09:00', to: '17:00' },
  saturday: { open: false, from: '09:00', to: '17:00' },
  sunday: { open: false, from: '09:00', to: '17:00' },
};
